import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import oz from "./locales/oz.json";

export const i18n = createI18n({
  legacy: false,
  locale: "oz",
  fallbackLocale: "oz",
  messages: { oz, ru, en },
});

// Function to set the locale after Pinia is active
export function setI18nLocale(localeStore) {
  i18n.global.locale.value = localeStore.locale.value || "oz";
}
